export default __webpack_public_path__ + "ed4988a97522ee8a30edf5a6a92b3726.png";